// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_njB","delete":"styles_delete__3x5-T","update":"styles_update__3pmak","add":"styles_add__OW-TO"};